import { GET_CHAT, DISPLAY_INPUT_OPTION, UPDATE_USER_COUPON, SUBMIT_CHAT, FORCE_OPEN} from '../actions/chat/type';
const initState = {chat: [], message: null, inputVisibility: false, collect_coupon: null, submitMessage: {type: null, message: null}, forceOpen: false}
export default function(state = initState, action) {
    switch (action.type) {
    case GET_CHAT:
        return {...state, message : action.payload};
    case DISPLAY_INPUT_OPTION:
        return {...state, inputVisibility : action.payload};
    case UPDATE_USER_COUPON:
        return {...state, collect_coupon : action.payload};
    case SUBMIT_CHAT: 
        const {type, message} = action.payload
        return {...state, submitMessage: {type, message}};
    case FORCE_OPEN:
        const {payload} = action
        return {...state, forceOpen: payload};
    default: 
        return state;
    }
}